export default __webpack_public_path__ + "assets/94603de790176f3ad40892521ba109f1.png";